export default __webpack_public_path__ + "static/media/smile.a2139865.svg";